<script lang="ts">
	import md from '$lib/utils/md';
	import { getCopy } from '$lib/lang/copy.svelte';

	const copy = $derived(getCopy().partner);
</script>

<div class="bg-blue-light w-full py-12 text-white">
	<div class="content-well flex flex-col gap-6">
		<p class="subtitle-1">{@html md(copy.hed)}</p>
		<div class="h-px bg-white"></div>
		<p class="heading-5">{@html md(copy.dek)}</p>
		<a
			href={copy.cta_url}
			target="_blank"
			rel="noreferrer noopener"
			class="hover:bg-red button text-blue-dark bg-yellow w-fit p-3 transition-colors hover:text-white"
		>
			{@html md(copy.cta)}
			<span class="sr-only">{@html md(copy.cta_hidden)}</span>
		</a>
	</div>
</div>
